import { AnalyticsDataFrameGroupedDonutController } from './analytics-data-frame-grouped-donut.controller'

function analyticsDataFrameGroupedDonut () {
  return {
    restrict: 'E',
    scope: {
      data: '<',
      filterParams: '<',
      slug: '<',
      loadingDataFrames: '=',
      noEmptyModeDescription: '<',
      fullWidth: '<'
    },
    templateUrl: '/analytics/directives/analytics-data-frame-grouped-donut/analytics-data-frame-grouped-donut-directive.html?$$REVISION$$',
    controller: AnalyticsDataFrameGroupedDonutController
  }
}

export { analyticsDataFrameGroupedDonut }
